// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag__wrapper[data-v-2f222f52]{margin-top:65px}@media (max-width:767px){.tag__wrapper[data-v-2f222f52]{margin-top:50px}}", ""]);
// Exports
module.exports = exports;
